import { gameTracking } from '../../Utility/Tracking/FBLegacyTracking';
import { ProductID, ProductValueMap, PurchaseStatus } from './Product';

export function trackPurchase(ID: ProductID, status: PurchaseStatus) {
    switch (status) {
        case PurchaseStatus.START:
            gameTracking(ProductValueMap[ID].trackingStart);
            break;
        case PurchaseStatus.SUCCESS:
            gameTracking(ProductValueMap[ID].trackingSuccess);
            break;
        case PurchaseStatus.FAIL:
            gameTracking(ProductValueMap[ID].trackingFail);
            break;
    }
}
